import React, { useEffect } from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import useAuth from '../../context/auth/useAuth'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { getMultiSchools } from '../../actions/schoolsActions'
import { CustomDataTable } from '../../components/design/Datatables/CustomDataTable'
import { Link } from 'react-router-dom'


export default function MultiSchools() {
    const { t } = useTranslation()
    const {client} = useAuth()
	const dispatch = useDispatch()
	const {schools} = useSelector(state=>state.schools)

	useEffect(() => {
		if(client){
			dispatch(getMultiSchools())
		}
	},[dispatch, t, client])

	const columnsSchools = [
		{
			name: t('admin.dashboard.name'),
			cell: school =>
				<div className='text-left'>
					{school.email}
				</div>,
			selector: (school) => school.email,
			sortable: true,
		},
		{
			name: t('admin.dashboard.schools'),
			cell: school =>
				<div className='text-left'>
					{school.schools?.map(s => s.name).join(', ')}
				</div>,
			selector: (school) => school.email,
			sortable: true,
		},
		{
			name: t('global.actions'),
			cell: school =>
				<div>
					<Link to={`/admin/multischools/edit/${school._id}`}>
						<img src="/images/edit.svg" alt="Editar" className='me-3' />
					</Link>
				</div>,
			selector: (school) => school._id,
			sortable: false,
		}
	]

	return (
		<>
			<Container className='cuerpo'>
				<Row>
					<h1>{t('admin.dashboard.schools')}</h1>
				</Row>
				<Row className="mt-2">
					<Col>
						<Card className='mb-5 sombra'>
                            <Card.Body className='px-5 pt-5'>
								<div className='d-flex justify-content-end'>
									<Link to="/admin/multischools/new" className='btn btn-primary'><i className='fas fa-plus me-2'/>{t("admin.dashboard.createMultiSchool")}</Link>
								</div>
								{schools?.length > 0
									?
										<CustomDataTable columns={columnsSchools} data={schools} />
									:
										<div className='mb-3'>{t('admin.dashboard.thereisnotschools')}</div>
								}
							</Card.Body>

						</Card>
					</Col>
				</Row>
			</Container>
        </>
    )
}